import { connect } from 'react-redux';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { AccountType } from '@mews-commander/data-access';
import { OptimusPlainLink } from '@mews-commander/ui';
import { Banner } from '@optimus-web/core';
import { CommanderThunkAction } from '@mews-commander/types';
import { mergeAccounts, MergeAccountsProps } from '../actions';

interface AccountMergeSuggestionBannerProps extends MergeAccountsProps {
    openMergeAccountsDialog: (mergeAccountOptions: MergeAccountsProps) => void;
}

interface DispatchProps {
    openMergeAccountsDialog: (mergeAccountOptions: MergeAccountsProps) => CommanderThunkAction;
}

const AccountMergeSuggestionBanner = ({
    accountId,
    otherAccountId,
    openMergeAccountsDialog,
    accountType,
}: AccountMergeSuggestionBannerProps) => {
    const handleMergeSuggestionClick = () => {
        openMergeAccountsDialog({ accountId, otherAccountId, accountType });
    };

    const mergeSuggestionMessage =
        accountType === AccountType.Company
            ? TextKey.MergeCompaniesSuggestionMessage
            : TextKey.MergeCustomersSuggestionMessage;

    const bannerTitle = <LocalizedText textKey={TextKey.MergeSuggestion} />;
    const bannerContent = (
        <>
            <LocalizedText textKey={mergeSuggestionMessage} />{' '}
            <OptimusPlainLink onClick={handleMergeSuggestionClick} inherit>
                <LocalizedText textKey={TextKey.MergeSuggestionLinkMessage} />
            </OptimusPlainLink>
        </>
    );

    return <Banner variant="warning" primaryText={bannerTitle} secondaryText={bannerContent} />;
};

type OwnProps = Pick<MergeAccountsProps, 'accountId' | 'otherAccountId'>;

export default connect<{}, DispatchProps, OwnProps>(undefined, {
    openMergeAccountsDialog: mergeAccounts,
})(AccountMergeSuggestionBanner);
